import { useEffect, useState } from "react";
import type { LiveQuery } from "@roqeet/core";

/**
 * Subscribe a React component to a core {@link LiveQuery} (decision #13).
 * The query is the source of truth: the component re-renders whenever the
 * underlying IndexedDB data changes, with no manual cache to keep in sync.
 *
 * `deps` controls when the query is re-created (e.g. when the active chat id
 * changes). The factory is intentionally not in deps to avoid resubscribing on
 * every render.
 */
export function useLive<T>(factory: () => LiveQuery<T>, deps: unknown[]): T | undefined {
  const [value, setValue] = useState<T | undefined>(undefined);

  useEffect(() => {
    const query = factory();
    const unsubscribe = query.subscribe(
      (v) => setValue(v),
      (e) => console.error("liveQuery error", e),
    );
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return value;
}
